module.exports = __webpack_public_path__ + "img/step2-c.3b2b4ecb.png";